import { DocumentSection } from "../_interfaces/document";

export function mapNoteSection(sectionsObject: any = {}): Record<string, DocumentSection> {
  const sectionsSrc = sectionsObject || {};
  const sections: Record<string, DocumentSection> = {};
  
  for (const k of Object.keys(sectionsSrc)) {
    const s = sectionsSrc[k] || {};
    sections[k] = {
      title: s?.title ?? '',
      text: s?.content ?? s?.text ?? ''
    };
  }
  
  return sections;
}

